module.exports = __webpack_public_path__ + "img/team-07.4ebabf45.jpg";